import React, { useState, useEffect } from "react";
import {
  Grid,
  Card,
  Tabs,
  Tab,
  TextField,
  Button,
  Backdrop,
  CircularProgress,
  MenuItem,
  FormControl, InputLabel, Select,
} from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'; // Make sure you import this
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import { url, fileUploadUrl } from "../../constant";

function FooterLinkDashboard() {
  const [tab, setTab] = useState(0);

  // Sample static data for footer links
  const [links, setLinks] = useState([
    {
      id: 1,
      link_text: "Privacy Policy",
      link_url: "/privacy-policy",
      footer_section_id: "About Us",
    },
    {
      id: 2,
      link_text: "Terms of Service",
      link_url: "/terms",
      footer_section_id: "About Us",
    },
    {
      id: 3,
      link_text: "Blog",
      link_url: "/blog",
      footer_section_id: "Resources",
    },
  ]);

  const [sections, setSections] = useState([]); // For dropdown of sections

  const [formState, setFormState] = useState({
    link_text: "",
    link_url: "",
    footer_section_id: "",
  });

  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [currentPageIndex, setCurrentPageIndex] = useState(0); // Manage pagination state

  useEffect(() => {
    fetchFooterLinks();
    fetchFooterSections();
  }, []);

  const fetchFooterLinks = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${url}auth/get-footer-links`);
      if (!res.ok) throw new Error(`Error: ${res.status}`);

      const data = await res.json();

      console.log("get-footer-links", data);

      setLinks(data);
    } catch (err) {
      console.log("err", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchFooterSections = async () => {
    try {
      const res = await fetch(`${url}auth/get-footer-sections`);
      if (!res.ok) throw new Error(`Error: ${res.status}`);
      const data = await res.json();
      setSections(data);
    } catch (error) {
      console.error("Failed to fetch footer sections:", error);
    }
  };


  const columns = [
    { Header: "ID", accessor: "id" },
    { Header: "Title", accessor: "link_text" },
    { Header: "URL", accessor: "link_url" },
    {
      Header: "Section",
      accessor: "footer_section_id",
      Cell: ({ value }) => {
        const section = sections.find((s) => s.id === value);
        return section ? section.section_title : value;
      },
    },
    {
      Header: "Actions",
      accessor: "actions",
      Cell: ({ row }) => (
        <>
          
          <Button
            variant="contained"
            size="small"
            sx={{ backgroundColor: "#183759", color: "#fff", "&:hover": { backgroundColor: "#204b80" } }}
            onClick={() => {
              const link = row.original;
              setFormState({
                link_text: link.link_text,
                link_url: link.link_url,
                footer_section_id: link.footer_section_id,
              });
              setEditId(link.id);
              setTab(1);
            }}
          >
            Edit
          </Button>

          {/* Delete Button */}
          <Button
            variant="contained"
            color="error"
            size="small"
            onClick={() => handleDelete(row.original.id)}
            sx={{
              fontWeight: 'bold',
              padding: '8px 16px',
              backgroundColor: '#d32f2f',
              color: '#fff',
              '&:hover': { backgroundColor: '#c62828' },
              marginLeft: 2
            }}

          >
            {/* Delete */}
            Cancella
          </Button>

        </>
      ),
    },
  ];

  const rows = links.map((l) => ({ ...l, actions: "" }));


  const handleSave = async () => {
    if (!formState.link_text || !formState.link_url || !formState.footer_section_id) {
      alert("Please fill all fields");
      return;
    }

    setFormLoading(true);

    const payload = {
      link_text: formState.link_text,
      link_url: formState.link_url,
      footer_section_id: formState.footer_section_id,
    };
    // console.log(payload);
    // return;
    try {
      let res;
      if (editId) {
        res = await fetch(`${url}auth/update-footer-link/${editId}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
      } else {
        res = await fetch(`${url}auth/create-footer-link`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
      }

      if (!res.ok) throw new Error(`Failed to save: ${res.status}`);

      const savedLink = await res.json();

      if (editId) {
        setLinks((prev) =>
          prev.map((l) => (l.id === editId ? savedLink.data : l))
        );
      } else {
        setLinks((prev) => [...prev, savedLink.data]);
      }

      setFormState({ link_text: "", link_url: "", footer_section_id: "" });
      setEditId(null);
      setTab(0);
    } catch (error) {
      console.error(error);
      alert("Failed to save footer link.");
    } finally {
      setFormLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Sei sicuro di voler eliminare questo link?")) {
      return; // User cancelled deletion
    }

    setLoading(true);
    try {
      const res = await fetch(`${url}auth/delete-footer-link/${id}`, {
        method: "DELETE",
      });

      if (!res.ok) {
        // Try to get error message from backend
        const errorData = await res.json().catch(() => null);
        const errorMessage =
          (errorData && errorData.message) || `Failed to delete: ${res.status}`;
        throw new Error(errorMessage);
      }

      // Remove deleted link from state
      setLinks((prev) => prev.filter((link) => link.id !== id));

      // Reset form if editing deleted link
      if (editId === id) {
        setFormState({ link_text: "", link_url: "", footer_section_id: "" });
        setEditId(null);
        setTab(0);
      }
    } catch (err) {
      console.error(err);
      alert(err.message || "Errore durante l'eliminazione del link.");
    } finally {
      setLoading(false);
    }
  };


  return (
    <DashboardLayout>
      <DashboardNavbar />

      <Backdrop open={loading || formLoading} sx={{ zIndex: 1000 }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="#183759"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Footer Links
                </MDTypography>
              </MDBox>

              <Tabs value={tab} onChange={(e, val) => setTab(val)} variant="fullWidth">
                <Tab label="Links List" />
                <Tab label={editId ? "Edit Link" : "New Link"} />
              </Tabs>

              {tab === 0 && (
                <MDBox pt={3}>
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={{ defaultValue: 10 }}
                    showTotalEntries={false}
                    noEndBorder
                    currentPageIndex={currentPageIndex}
                    setCurrentPageIndex={setCurrentPageIndex}
                  />
                </MDBox>
              )}

              {tab === 1 && (
                <MDBox pt={3} px={2}>
                  <Grid container justifyContent="center">
                    <Grid item xs={12} sm={8} md={6}>
                      <TextField
                        label="Title"
                        fullWidth
                        value={formState.link_text}
                        onChange={(e) =>
                          setFormState({ ...formState, link_text: e.target.value })
                        }
                        sx={{ mb: 2 }}
                      />
                      <TextField
                        label="URL"
                        fullWidth
                        value={formState.link_url}
                        onChange={(e) =>
                          setFormState({ ...formState, link_url: e.target.value })
                        }
                        sx={{ mb: 2 }}
                        helperText="e.g. /privacy-policy"
                      />
                      <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel id="footer-section-label">Section</InputLabel>
                        <Select
                          labelId="footer-section-label"
                          id="footer-section-select"
                          value={formState.footer_section_id}
                          label="Section"
                          onChange={(e) => setFormState({ ...formState, footer_section_id: e.target.value })}
                          IconComponent={ArrowDropDownIcon}
                          sx={{
                            height: 45,
                            '& .MuiSelect-icon': {
                              fontSize: '1.6rem', // bigger dropdown icon
                            },
                          }}
                        >
                          {sections.length === 0 ? (
                            <MenuItem disabled>
                              <CircularProgress size={24} sx={{ mr: 1 }} />
                              Loading...
                            </MenuItem>
                          ) : (
                            sections.map((section) => (
                              <MenuItem key={section.id} value={section.id}>
                                {section.section_title}
                              </MenuItem>
                            ))
                          )}
                        </Select>
                      </FormControl>
                      <Button
                        variant="contained"
                        fullWidth
                        onClick={handleSave}
                        sx={{ mb: 5, backgroundColor: "#183759", color: "#fff", "&:hover": { backgroundColor: "#204b80" } }}
                      >
                        {editId ? "Update" : "Save"}
                      </Button>
                    </Grid>
                  </Grid>
                </MDBox>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Footer />
    </DashboardLayout>
  );

}

export default FooterLinkDashboard;
